(() => {
  const applyVariantTitle = (variant) => {
    const heading = document.querySelector('.nutra-pdp__title h1');
    if (!heading || !variant) return;

    const key = String(variant.title || variant.name || '').toLowerCase();
    let nextTitle = heading.dataset.titleDefault || '';

    if (key.indexOf('decaf') !== -1 && heading.dataset.titleDecaf) {
      nextTitle = heading.dataset.titleDecaf;
    } else if (key.indexOf('caffeine') !== -1 && heading.dataset.titleCaffeine) {
      nextTitle = heading.dataset.titleCaffeine;
    }

    if (nextTitle) heading.textContent = nextTitle;
  };

  const applyFlavorLabel = (input) => {
    const nameEl = document.querySelector('[data-nutra-flavor-selected]');
    if (!nameEl || !input) return;
    const label = input.getAttribute('data-label');
    if (label) nameEl.textContent = label;
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input || !input.closest || !input.closest('.nutra-pdp__flavor-options')) return;
    applyVariantTitle({ title: input.value || '' });
    applyFlavorLabel(input);
  });

  const bind = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      window.setTimeout(bind, 50);
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      applyVariantTitle(event?.data?.variant);
      const checked = document.querySelector('.nutra-pdp__flavor-options input:checked');
      applyFlavorLabel(checked);
    });
  };

  bind();
})();
